import { render, staticRenderFns } from "./CommodityScenarios.vue?vue&type=template&id=4410d2c6&scoped=true&"
import script from "./CommodityScenarios.vue?vue&type=script&lang=js&"
export * from "./CommodityScenarios.vue?vue&type=script&lang=js&"
import style0 from "./CommodityScenarios.vue?vue&type=style&index=0&id=4410d2c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4410d2c6",
  null
  
)

export default component.exports